import * as React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Header from '@layout/HeaderTemplates/Base';
import K12Container from '@cont/K12/k12';
import BaseFooter from '@layout/Footer/BaseFooter';
import { breakpoints } from '@styles/index';
import getK12Info from '@cms/api';
import setupInitialProps from '@utils/setupInitialProps';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const StyledBaseFooter = styled(BaseFooter)`
  margin-top: 0;
  @media (max-width: ${breakpoints.tablet}) {
    & > div {
      width: 728px;
      justify-content: space-between;
    }
  }
  @media (max-width: ${breakpoints.mobile}) {
    & > div {
      width: 100%;
    }
  }
`;

function K12({ apiResponse }) {
  const [showLeadgen, setShowLeadGen] = React.useState(false);
  return (
    <>
      <Header />
      <K12Container
        showLeadgen={showLeadgen}
        setShowLeadGen={setShowLeadGen}
        apiResponse={JSON.parse(apiResponse)}
      />
      <StyledBaseFooter display />
    </>
  );
}

const Layout = ({ children }) => <>{children}</>;
K12.Layout = Layout;

K12.pageInfo = {
  isMWebSupported: true,

  layoutOptions: {
    disableDarkMode: true
  }
};

K12.propTypes = {
  apiResponse: PropTypes.string.isRequired
};
K12.getInitialProps = setupInitialProps(async () => {
  const response = await getK12Info('api/k12-info/cbse-class-6-12/');
  return { apiResponse: JSON.stringify(response) };
}, K12.pageInfo);

Layout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default K12;
K12.Wrapper = PageReduxProvider;
